<div [formGroup]="freeSearchForm" [ngClass]="theme()" class="free-search-container">
  <mat-form-field appearance="outline">
    <div class="input-wrapper">
      <div class="search-wrapper">
        <div class="search-icon-wrapper">
          <app-ui-icon color="var(--grey-3)" name="search" size="md"></app-ui-icon>
        </div>
        <input
          #freeSearchInput
          (focus)="onFocus($event)"
          (keydown.enter)="onEnterHit()"
          [matAutocomplete]="auto"
          class="test-search-autocomplete-input"
          formControlName="term"
          matInput
          placeholder="Sök efter vårdtjänst, mottagning eller ort"
          type="search"
        >
        @if (freeSearchForm.controls.term.value) {
          <div
            (click)="onClear()"
            class="close-icon-wrapper"
          >
            <app-ui-icon color="var(--grey-3)" name="close" size="md"></app-ui-icon>
          </div>
        }
      </div>
    </div>
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="handleOptionSelected($event)"
      class="test-search-autocomplete-modal"
    >
      @for (suggestItem of filteredSuggestItems(); let i = $index; track suggestItem.suggestValue) {
        <mat-option
          [id]="'suggestion-' + i"
          [ngClass]="'test-search-autocomplete-option-' + i"
          [value]="suggestItem.suggestValue"
        >
          <span
            [ngClass]="'test-search-autocomplete-item-' + i"
            class="suggest-item"
          >{{ suggestItem.suggestValue }}
          </span>
          <small
            [ngClass]="'test-search-autocomplete-item-annotation-' + i"
            class="suggest-item-annotation"
          >{{ suggestItem.suggestLabel }}</small
          >
        </mat-option>
      }

    </mat-autocomplete>
  </mat-form-field>
</div>
